document.addEventListener('DOMContentLoaded', function() {
  // 1. Identifica los elementos input radio que controlan el color.
  const colorSelectors = document.querySelectorAll('input[name="Color"]');

  // 2. Identifica el contenedor del carrusel de imágenes.
  const imageCarouselContainer = document.querySelector('.primgSlider');

  if (colorSelectors && imageCarouselContainer) {
    colorSelectors.forEach(selector => {
      selector.addEventListener('change', function() {
        // Cuando el valor del selector de color cambia
        window.scrollTo({
          top: imageCarouselContainer.offsetTop,
          behavior: 'smooth'
        });
      });
    });
  }
});